import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { api } from '../../../static/api';
import { QueryAliases } from '../../../types/QueryAliases';
import { getApiErrorMessage } from '../../../utils/api/getApiErrorMessage';
import useAxiosInstance from '../../axios/useAxiosInstance';
import useToast from '../../useToast';

interface UpdatePlayerData {
  id: string;
  email?: string;
  name?: string;
  phone?: string;
}

const useUpdatePlayer = () => {
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();
  const { showErrorToast, showSuccessToast } = useToast();
  const { t } = useTranslation();

  const { mutateAsync, isLoading } = useMutation(
    ({ id, ...data }: UpdatePlayerData) => axiosInstance.patch(api.endpoints.UPDATE_RELATED_USER({ id }), data),
    {
      async onSuccess() {
        await queryClient.refetchQueries([QueryAliases.RELATED_USERS]);
        showSuccessToast(t('account.players.editSuccess'));
      },
      onError: (err: AxiosError) => {
        const errorMessage = getApiErrorMessage(err) ?? t('errorMessages.updateReletedUserFailed');

        showErrorToast(errorMessage);
      },
    },
  );

  return { updatePlayer: mutateAsync, isLoading };
};

export default useUpdatePlayer;
